module.exports = __webpack_public_path__ + "img/promotions-bg.jpg?0d08e18195050fa426ed226552835667";